import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { Dropdown, Menu, Row, Col } from 'antd';

import {
  URL_HS_MAIN_PAGE,
  URL_HS_SEARCH_HOST_PAGE,
  URL_HS_RENO_CALC_PAGE,
  URL_HS_ENQUIRY_PAGE,
  URL_HS_HOST_LISTING_PAGE,
  URL_HAS_MAIN_PAGE,
  URL_HAS_CAMPAIGN_PAGE,
  URL_HS_HOST_REGISTER_PAGE,
  URL_HAS_ABOUT_US_PAGE,
  URL_HAS_TEAM_PAGE,
  URL_HAS_EVENTS_PAGE,
  URL_HAS_RESOURCES_PAGE,
  URL_HAS_BLOG_PAGE,
  URL_HAS_HOST_PAGE,
  URL_HAS_HOST_360,
} from 'utils/urls';
import HostAStayLogo from '../../images/has-logo-with-padding.png';

const { Item: MenuItem, SubMenu: SubMenuItem } = Menu;

const IconDiv = styled.div`
  height: 100%;
`;

const IconImg = styled.img`
  height: ${props => props.theme.header.mobile.iconHeight}px;

  @media (min-width: 768px) {
    height: ${props => props.theme.header.desktop.iconHeight}px;
  }
`;

const HostSearchIcon = () => {
  return (
    <IconDiv>
      <a href={URL_HAS_MAIN_PAGE}>
        <IconImg src={HostAStayLogo} />
      </a>
    </IconDiv>
  );
};

const DropdownCol = styled(Col)`
  height: 51px;
  :hover {
    border-bottom: 3px solid ${props => props.theme.color.secondary};
  }
`;

const DropdownTitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px !important;
  color: ${props => props.theme.color.white};
  font-weight: 700;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 13px;
    line-height: 52px;
  }
`;

const DropdownMenu = styled(Menu)`
  top: -5px !important;
  background-clip: unset !important;
  border-radius: 0 !important;
  width: 208px !important;
  padding: 0 !important;
  background-color: ${props => props.theme.color.primary} !important;
`;

const DropdownSubMenu = styled(SubMenuItem)`
  text-align: left !important;
  font-size: 12px !important;
  line-height: 30px !important;
  color: ${props => props.theme.color.white} !important;
  background-color: ${props => props.theme.color.primary} ;
`;

const DropdownMenuItem = styled(MenuItem)`
  text-align: left !important;
  font-size: 12px !important;
  line-height: 30px !important;
  color: ${props => props.theme.color.white} !important;
  background-color: ${props => props.theme.color.primary};
`;

const DropdownMenuLink = styled.a`
  color: ${props => props.theme.color.white} !important;
  :hover {
    background-color: ${props => props.theme.color.secondary};
  }
`;

const ExternalLinkTitle = ({ title, link }) => <DropdownTitle onClick={() => (window.location = link)}>{title}</DropdownTitle>;

const InternalLinkTitle = ({ title, link }) => (
  <Link to={link}>
    <DropdownTitle>{title}</DropdownTitle>
  </Link>
);

const DropdownTitleContent = ({ title, link, isExternal }) => {
  if (link) {
    return isExternal ? <ExternalLinkTitle title={title} link={link} /> : <InternalLinkTitle title={title} link={link} />;
  } else {
    return <DropdownTitle>{title}</DropdownTitle>;
  }
};

const SitemapDropdown = ({ title, titleLinkDetails, links, ...props }) => {
  const menu = (
    <DropdownMenu>
      {links &&
        links.map(link =>
          link.sublinks ? (
            <DropdownSubMenu key={link.title} title={link.title}>
              {link.sublinks.map(sublink => (
                <DropdownMenuItem key={sublink.title}>
                  <DropdownMenuLink href={sublink.toUrl} target={sublink.target}>
                    {sublink.title}
                  </DropdownMenuLink>
                </DropdownMenuItem>
              ))}
            </DropdownSubMenu>
          ) : (
            <DropdownMenuItem key={link.title}>
              <DropdownMenuLink href={link.toUrl} target={link.target}>
                {link.title}
              </DropdownMenuLink>
            </DropdownMenuItem>
          )
        )}
    </DropdownMenu>
  );
  return (
    <DropdownCol {...props}>
      <Dropdown overlay={menu} trigger={['click', 'hover']} placement="bottomLeft">
        <div>
          <DropdownTitleContent
            title={title}
            link={titleLinkDetails && titleLinkDetails.link}
            isExternal={titleLinkDetails && titleLinkDetails.isExternal}
          />
        </div>
      </Dropdown>
    </DropdownCol>
  );
};

const Root = styled.div`
  height: 52px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px) {
    display: none;
  }

  @media (min-width: 1200px) {
    align-items: center;
  }
`;

const headerList = [
  {
    title: 'CAMPAIGN',
    link: URL_HAS_CAMPAIGN_PAGE,
    isExternal: true
  },
  {
    title: 'OWNER',
    link: URL_HS_MAIN_PAGE,
    isExternal: false,
    sublinks: [
      {
        title: 'Search Host',
        toUrl: URL_HS_SEARCH_HOST_PAGE
      },
      {
        title: 'Reno Calculator',
        toUrl: URL_HS_RENO_CALC_PAGE
      },
      {
        title: 'Enquiry',
        toUrl: URL_HS_ENQUIRY_PAGE
      }
    ]
  },
  {
    title: 'HOST',
    link: URL_HAS_HOST_PAGE,
    isExternal: true,
    sublinks: [
      {
        title: 'Host360°',
        toUrl: URL_HAS_HOST_360,
        // Temporary close this down due to the difficulty of building sub items.
        // sublinks: [
        //   {
        //     title: 'Short Stay Management System',
        //     toUrl: URL_HP_PAGE,
        //     target: '_blank'
        //   },
        //   {
        //     title: 'Short Stay Insurance',
        //     toUrl: URL_HAS_HOST_PROTECT_PAGE
        //   },
        //   {
        //     title: 'Interior Design & Renovation',
        //     toUrl: URL_DAS_PAGE,
        //     target: '_blank'
        //   }
        // ]
      },
      {
        title: 'Our Host Partners',
        toUrl: URL_HS_HOST_LISTING_PAGE
      },
      {
        title: 'Join the Host Community',
        toUrl: URL_HS_HOST_REGISTER_PAGE
      }
    ]
  },
  {
    title: 'ABOUT US',
    link: URL_HAS_ABOUT_US_PAGE,
    isExternal: true,
    sublinks: [
      {
        title: 'Our Team',
        toUrl: URL_HAS_TEAM_PAGE
      }
    ]
  },
  {
    title: 'EVENTS',
    link: URL_HAS_EVENTS_PAGE,
    isExternal: true
  },
  {
    title: 'RESOURCES',
    link: URL_HAS_RESOURCES_PAGE,
    isExternal: true,
    sublinks: [
      {
        title: 'Blog',
        toUrl: URL_HAS_BLOG_PAGE
      }
    ]
  }
];

const DesktopHeader = () => {
  return (
    <Root>
      <HostSearchIcon />
      <Row
        type="flex"
        justify="space-between"
        align="middle"
        gutter={{ xs: 8, sm: 8, lg: 24 }}
        style={{ height: 50, justifyContent: 'space-between' }}
      >
        {headerList.map(header => (
          <SitemapDropdown
            key={header.title}
            title={header.title}
            titleLinkDetails={header.link ? { link: header.link, isExternal: header.isExternal || true } : undefined}
            links={header.sublinks && header.sublinks.length > 0 ? header.sublinks : undefined}
          />
        ))}
      </Row>
    </Root>
  );
};

export default DesktopHeader;
